import { AcademyFetchingClient } from 'academy-common-lib/utils/DataFetchingClient';
const getNewDataFetchingClient = () => new AcademyFetchingClient({
  assumeImmutableResults: true
});
export const dataFetchingClient = getNewDataFetchingClient();